import Splide from '@splidejs/splide';

let sliderSlider = document.getElementsByClassName('vacancy-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < sliderSlider.length; i++) {
        let splide = new Splide(sliderSlider[i], {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            rewind: false,
            gap: 32,
            pagination: false,
            arrows: true,
            width: '100%',
            breakpoints: {
                768: {
                    perPage: 1,
                },
            }
        });

        let bar = splide.root.querySelector('.splide-progress-bar');
        let track = splide.root.querySelector('.splide__track');
        track.classList.add('hasOverflow');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.mount();
    }
});
